import Vue, { createApp } from "vue";

import LayeredImagery from "./MainContent.vue";
import FolderView from "./FolderView.vue";

import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import vuetify from "../plugins/vuetify";

import './assets/Roboto.ttf';
import './assets/RobotoCondensed.ttf';

import { WWTComponent, wwtPinia } from "@wwtelescope/engine-pinia";

import Notifications from '@kyvg/vue3-notification';

import "leaflet/dist/leaflet.css";

/** v-hide directive taken from https://www.ryansouthgate.com/2020/01/30/vue-js-v-hide-element-whilst-keeping-occupied-space/ */
// Extract the function out, up here, so I'm not writing it twice
const update = (el: HTMLElement, binding: Vue.DirectiveBinding) => el.style.visibility = (binding.value) ? "hidden" : "";

createApp(LayeredImagery, {
  wwtNamespace: "wwt-minids-layeredimagery",
  wtml: { // images are listed in chronological order earliest to latest
    layeredimagery: "https://data1.wwtassets.org/packages/2023/06_pas/pillarsofcreation_v9.wtml",
  },
  url: "https://web.wwtassets.org/specials/2023/cosmicds-carina/",
  thumbnailUrl: "https://cdn.worldwidetelescope.org/thumbnails/jwst.jpg",
  bgWtml: "https://data1.wwtassets.org/packages/2023/04_casA/StudyBackgroundImagery.wtml",
  fgName: "Deep Star Maps 2020",
  bgName: "PanSTARRS1 3pi",
  title: "Pillars of Creation",
  introTitle: "Interactively Explore Pillars of Creation Imagery!",
  introText: `The Pillars of Creation, located in the Eagle Nebula, are remarkable 
  structures of interstellar gas and dust. These towering pillars are a 
  stellar nursery, where new stars form from the forces of gravity and 
  radiation. Spanning light-years in length, they showcase the illuminated 
  gas and dark, dense regions influenced by the intense ultraviolet light 
  emitted by nearby massive stars. The Pillars of Creation symbolize the 
  continuous cycle of stellar birth and death, offering a captivating 
  reminder of the immense and magnificent universe we inhabit.`,
  introInstructions: `Pan and zoom to explore the images. 
  Select the thumbnails to view Pillars of Creation astro-imagery 
  in context of the sky. Using the menu (top right), change the background imagery to compare 
  against different surveys and wavelengths.`
})

  // Plugins
  .use(wwtPinia)
  .use(vuetify)
  .use(Notifications)

  // Directives
  .directive(
    /**
    * Hides an HTML element, keeping the space it would have used if it were visible (css: Visibility)
    */
    "hide", {
      // Run on initialisation (first render) of the directive on the element
      beforeMount(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      },
      // Run on subsequent updates to the value supplied to the directive
      updated(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      }
    })

  // Components
  .component("WorldWideTelescope", WWTComponent)

  .component('folder-view', FolderView)
  .component('vue-slider', VueSlider)
  .component('date-picker', Datepicker)

  // Mount
  .mount("#app");
